import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';
export const GET_BNPL_SUMMARY_REQUEST = 'GET_BNPL_SUMMARY_REQUEST';
export const GET_BNPL_SUMMARY_SUCCESS = 'GET_BNPL_SUMMARY_SUCCESS';
export const GET_BNPL_SUMMARY_ERROR = 'GET_BNPL_SUMMARY_ERROR';
export function fetchBnplSummary() {
    return (dispatch) => {
        dispatch({
            type: GET_BNPL_SUMMARY_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/affordability/bnpl/cockpit_summary',
            action: GET_BNPL_SUMMARY_REQUEST
        })).then(json => dispatch({
            type: GET_BNPL_SUMMARY_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: GET_BNPL_SUMMARY_ERROR,
                error: err
            });
        });
    };
}
export const GET_BNPL_MIGRATION_STATUS_REQUEST = 'GET_BNPL_MIGRATION_STATUS_REQUEST';
export const GET_BNPL_MIGRATION_STATUS_SUCCESS = 'GET_BNPL_MIGRATION_STATUS_SUCCESS';
export const GET_BNPL_MIGRATION_STATUS_ERROR = 'GET_BNPL_MIGRATION_STATUS_ERROR';
export function fetchBnplMigrationStatus() {
    return (dispatch) => {
        dispatch({
            type: GET_BNPL_MIGRATION_STATUS_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/fintech/redirection/action/MIGRATION',
            action: GET_BNPL_MIGRATION_STATUS_SUCCESS
        })).then(json => dispatch({
            type: GET_BNPL_MIGRATION_STATUS_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: GET_BNPL_MIGRATION_STATUS_ERROR,
                error
            });
        });
    };
}
export const GET_BNPL_DETAILS_REQUEST = 'GET_BNPL_DETAILS_REQUEST';
export const GET_BNPL_DETAILS_SUCCESS = 'GET_BNPL_DETAILS_SUCCESS';
export const GET_BNPL_DETAILS_ERROR = 'GET_BNPL_DETAILS_ERROR';
export function fetchBnplDetails() {
    return (dispatch) => {
        dispatch({
            type: GET_BNPL_DETAILS_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/affordability/bnpl/statements/cockpit',
            action: GET_BNPL_DETAILS_SUCCESS
        })).then(json => dispatch({
            type: GET_BNPL_DETAILS_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: GET_BNPL_DETAILS_ERROR,
                error: err
            });
        });
    };
}
export const GET_BNPL_LINKED_ACCOUNTS = 'GET_BNPL_LINKED_ACCOUNTS';
export const GET_BNPL_LINKED_ACCOUNTS_SUCCESS = 'GET_BNPL_LINKED_ACCOUNTS_SUCCESS';
export const GET_BNPL_LINKED_ACCOUNTS_ERROR = 'GET_BNPL_LINKED_ACCOUNTS_ERROR';
export function fetchBnplLinkedAccounts() {
    return (dispatch) => {
        dispatch({
            type: GET_BNPL_LINKED_ACCOUNTS
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/fintech/linkedAccounts',
            action: GET_BNPL_LINKED_ACCOUNTS_SUCCESS
        })).then(json => dispatch({
            type: GET_BNPL_LINKED_ACCOUNTS_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: GET_BNPL_LINKED_ACCOUNTS_ERROR,
                error: err
            });
        });
    };
}
export const DELINK_BNPL_APP = 'DELINK_BNPL_APP';
export const DELINK_BNPL_APP_SUCCESS = 'DELINK_BNPL_APP_SUCCESS';
export const DELINK_BNPL_APP_ERROR = 'DELINK_BNPL_APP_ERROR';
export function delinkBnplApp(payload) {
    return (dispatch) => {
        dispatch({
            type: DELINK_BNPL_APP
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/fintech/delinkAccount',
            action: DELINK_BNPL_APP_SUCCESS
        }), payload).then(() => dispatch({
            type: DELINK_BNPL_APP_SUCCESS,
            data: payload
        }), err => dispatch({
            type: DELINK_BNPL_APP_ERROR,
            error: err
        }));
    };
}
export const GET_PAYBACK_TOKEN_REQUEST = 'GET_PAYBACK_TOKEN_REQUEST';
export const GET_PAYBACK_TOKEN_SUCCESS = 'GET_PAYBACK_TOKEN_SUCCESS';
export const GET_PAYBACK_TOKEN_ERROR = 'GET_PAYBACK_TOKEN_ERROR';
export const RESET_PAYBACK_TOKEN = 'RESET_PAYBACK_TOKEN';
export function resetPaybackToken() {
    return (dispatch) => {
        dispatch({
            type: RESET_PAYBACK_TOKEN
        });
    };
}
export function fetchPaybackTokenRequest(params) {
    return (dispatch) => {
        dispatch({
            type: GET_PAYBACK_TOKEN_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers
        }, {
            pathname: '/api/1/affordability/bnpl/shylock/initiate',
            action: GET_PAYBACK_TOKEN_REQUEST
        }), params).then(json => dispatch({
            type: GET_PAYBACK_TOKEN_SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: GET_PAYBACK_TOKEN_ERROR,
                error
            });
        });
    };
}
export const GET_BNPL_ACCOUNT_REQUEST = 'GET_BNPL_ACCOUNT_REQUEST';
export const GET_BNPL_ACCOUNT_SUCCESS = 'GET_BNPL_ACCOUNT_SUCCESS';
export const GET_BNPL_ACCOUNT_ERROR = 'GET_BNPL_ACCOUNT_ERROR';
export function fetchBnplAccountDetails() {
    return (dispatch) => {
        dispatch({
            type: GET_BNPL_ACCOUNT_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/affordability/bnpl/account',
            action: GET_BNPL_ACCOUNT_SUCCESS
        })).then(json => dispatch({
            type: GET_BNPL_ACCOUNT_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: GET_BNPL_DETAILS_ERROR,
                error: err
            });
        });
    };
}
/**
 * Fetches Penalty FAQ data from server
 */
export let faqCache = {};
export function fetchBnplPenaltyFaq() {
    const settings = Object.assign({}, baseAjaxConfig, {
        pathname: '/api/1/affordability/bnpl/penalty_faq',
        action: 'GET_BNPL_PENALTY_FAQ'
    });
    return ApiCaller.get(settings).then(json => {
        faqCache = json.RESPONSE;
        return Promise.resolve(json.RESPONSE);
    }, error => {
        return Promise.reject(error);
    });
}
